<template>
	<div class="card-item secondary ratingInfo">
		<div class="header">
			<div class="title">Социальный рейтинг</div>
		</div>
		<div class="infos" v-if="!loading">
			<template v-if="rating !== null">
				<div class="scoreContainer">
					<div class="score" :class="{ positive: rating.swagScore > 0, negative: rating.swagScore < 0 }" title="Свага-метр (за текущий месяц)">
						{{ rating.swagScore > 0 ? '+' + rating.swagScore : rating.swagScore }}
					</div>
					<div class="score social" :class="{ positive: rating.socialRating > 0, negative: rating.socialRating < 0 }" title="Социальный рейтинг (за всё время)">
						({{ rating.socialRating > 0 ? '+' + rating.socialRating : rating.socialRating }})
					</div>
				</div>
			</template>
			<template v-else>
				<div class="noData">Нет данных или отключено на канале</div>
			</template>
		</div>
		<div class="infos" v-else>
			<Icon name="loader" alt="loading" class="loader"/>
		</div>
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
import TTButton from '../TTButton.vue';
import Icon from '../Icon.vue';
import SocialRatingApi from '@/utils/SocialRatingApi';
import type { CardRating } from '@/utils/SocialRatingApi';

@Component({
	components: { TTButton, Icon }
})
export default class SocialRating extends Vue {
	@Prop({ required: true }) public userLogin!: string;
	@Prop({ required: true }) public channelLogin!: string;

	public loading: boolean = true;
	public rating: CardRating | null = null;

	public async mounted(): Promise<void> {
		await this.loadRating();
	}

	@Watch("userLogin")
	public async onUserChanged(): Promise<void> {
		await this.loadRating();
	}

	public async loadRating(): Promise<void> {
		this.loading = true;
		this.rating = await SocialRatingApi.fetchRating(this.userLogin, this.channelLogin);
		this.loading = false;
	}
}
</script>

<style scoped lang="less">
.ratingInfo {
	.header {
		background-color: var(--color-button);
		// background-image: linear-gradient(90deg, var(--background-color-fadest), var(--background-color-transparent));
	}
	.infos {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.5em;
	}
	.scoreContainer {
		padding-top: 0.5em;
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5em;
	}
	.score {
		display: inline-block;
		font-family: var(--font-inter), sans-serif;
		font-size: 2em;
		font-weight: bold;
		color: var(--color-text);
		text-align: center;
		line-height: 1em;
	}
	.score.positive {
		color: var(--color-primary);
	}
	.score.negative {
		color: var(--color-alert);
	}
	.social {
		font-size: 1.5em;
	}
	.actions {
		display: flex;
		gap: 0.5em;
		justify-content: center;
	}
	.noData {
		font-style: italic;
		font-size: 0.9em;
		color: var(--color-text-fade);
		text-align: center;
	}

	background-color: rgba(87,87,92,0.5);
}
</style>
